<template>
  <div class="element-input element-content-radio">
    <template v-if="hasSubOptions">
        <ul>
          <li :class="{ on: subLabel == `[${popupHeaderTab}] ${item.label}` || subLabel == `[${popupHeaderTab}] ${item.value}` || multipleCheck(`[${popupHeaderTab}] ${item.label}`) }"
          v-for="item in items" @click="label === '품종' ? selectPetItem( item.label ) : selectItem({value: item.value, label: popupHeaderTab})">{{ item.label }}</li>
        </ul>
    </template>  
    <template v-else>
        <ul>
          <li :class="{ on: subLabel == item.label || subLabel == item.value || multipleCheck(item.label) }"
          v-for="item in items" @click="label === '품종' ? selectPetItem( item.label ) : selectItem( item.value )">{{ item.label }}</li>
        </ul>
    </template>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "subLabel", "autoName", "label", "error", "items", "data", "hasSubOptions", "popupHeaderTab" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "checkValue", value );
    },
    selectPetItem( value ){
      this.$emit( "checkPet", value );
    },
    multipleCheck(e) {
      if(this.subLabel.indexOf(',') >= 0){
        if(this.subLabel.indexOf(e) >= 0){
          return true;
        }
        return false;
      }else{
        return false;
      }
    }
  }
}
</script>
